<template>
  <v-container fluid>
    <v-card class="pa-6 mx-auto" elevation="4" max-width="600" rounded="xl">
      <h2 class="text-h5 mb-4">Validar líneas planificadas</h2>

      <div>Recuerda que las líneas se validan automáticamente cada día a las 11:00.</div>

      <v-btn @click="consultar" v-if="!carregant" color="orange" style="margin-top: 20px;">
        Validar líneas planificadas hasta ayer
      </v-btn>

      <div v-if="carregant" class="mt-4 d-flex flex-column align-center">
        <v-progress-circular indeterminate color="primary" />
        <div class="mt-2">{{ fase }}</div>
      </div>

      <v-alert
        v-if="missatge"
        :type="estat ? 'success' : 'error'"
        class="mt-3"
      >
        {{ missatge }}
      </v-alert>
    </v-card>
  </v-container>
</template>


<script setup>
import { ref } from 'vue'
import axios from 'axios'

const apiLong = axios.create({
  baseURL: '/',                   // si tens base global, pots ometre-ho
  timeout: 180000,                // 180s per operacions pesades
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
   
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// Helpers
const sleep = (ms) => new Promise(r => setTimeout(r, ms))
async function getWithRetry(url, opts = {}, retries = 1) {
  let attempt = 0, delay = 1500
  while (true) {
    try {
      return await apiLong.get(url, opts)
    } catch (err) {
      const status = err?.response?.status
      const retryable = err.code === 'ECONNABORTED' || (status >= 500 && status < 600)
      if (!retryable || attempt >= retries) throw err
      await sleep(delay); delay *= 2; attempt++
    }
  }
}

const carregant = ref(false)
const estat = ref(false)
const missatge = ref('')
const fase = ref('')

// ENDPOINTS (revisa que coincideixin amb les rutes Laravel)
const ENDPOINTS = {
  planificades: '/api/admin/planimetria/validar/planificades',
  noBuzoneo: '/api/admin/planimetria/validar/no-buzoneo',
  percentatge: '/api/admin/planimetria/percentatge_campanya',
}

const consultar = async () => {
  try {
    carregant.value = true

    fase.value = 'Validando líneas de Buzoneo...'
    await getWithRetry(ENDPOINTS.planificades)

    fase.value = 'Validando líneas extra (no Buzoneo)...'
    await getWithRetry(ENDPOINTS.noBuzoneo)

    fase.value = 'Calculando porcentaje de campaña...'
    // Opcional: acotar volum per accelerar
    // const params = { desde: '2025-10-01', fins: '2025-11-06' }
    await getWithRetry(ENDPOINTS.percentatge /*, { params } */)

    estat.value = true
    missatge.value = 'Validación y cálculos completados correctamente.'
  } catch (err) {
    console.error(err)
    estat.value = false
    missatge.value =  'Error al validar las líneas o calcular porcentajes.'
  } finally {
    fase.value = ''
    carregant.value = false
  }
}
</script>